import { IContactForm, IContactSaveRequestPayload } from 'contacts/types';
import { getEmailDomain } from 'contacts/utils';

export const mapContactForm = (
  data: IContactForm,
  contactGroupId: number,
  restoreDeleted: boolean,
  attachDomainConfirmed?: string
): IContactSaveRequestPayload => {
  // The attach is authorised for one specific domain, so an email edited after that confirmation
  // must not carry the flag — the BE would append whichever domain the email now has.
  const attachEmailDomain =
    Boolean(attachDomainConfirmed) && getEmailDomain(data.email) === attachDomainConfirmed;

  return {
    contact: {
      ...(data?.id && { id: data.id }),
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      ...(data?.mobile && { mobile: data.mobile }),
      ...(data?.phone && { phone: data.phone }),
      contactGroupingId: data?.contactGrouping?.id || null,
      billingAddressId: data.billTo.addressId,
      shippingAddressId: data.shipTo.addressId,
      sellingAddressId: data.soldTo.addressId,
      groupId: contactGroupId,
      ...(restoreDeleted && { deleted: 0 }),
      ...(data?.isDefault !== undefined && { isDefault: data.isDefault ? 1 : 0 }),
    },
    ...(data?.sendInvitation && { sendInvitation: 1 }),
    ...(attachEmailDomain && { attachEmailDomain: true }),
  };
};
